import { createStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    container: {
      width: '100%',
      padding: '24px 0px',
      gap: 16,
    },
    artistCard: {
      position: 'relative',
      alignItems: 'center',
      gap: 8,
      textDecoration: 'none',
    },
    artistImage: {
      width: 112,
      height: 138,
      borderRadius: 6,
      objectFit: 'cover',
    },
    artistsContainer: {
      overflowX: 'scroll',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    spotifyLogo: {
      position: 'absolute',
      top: 106,
      right: 8,
    },
  });

export default styles;
